import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a mailing by its ID for a specific user.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing to delete.
 * @param userId - The unique identifier of the user performing the deletion.
 * @returns A promise that resolves to the operation result of the deletion.
 * @throws Will throw an error if the HTTP request fails.
 */
export const deleteMailing = async (instance: KyInstance, mailingId?: number, userId?: number) => {
  try {
    if (isNotDefined(mailingId) || isNotDefined(userId)) {
      throw new Error('Mailing ID and User ID must be provided to delete a mailing.');
    }

    return await instance
      .delete<OperationResult>(formatString(Uri.mailing.deleteMailing, mailingId.toString(), userId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
